import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative mt-2 rounded-md" }
const _hoisted_2 = { class: "text-sm font-semibold capitalize text-slate-900 flex items-center space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: "text-blue-500 rounded focus:ring-blue-500 focus:border-blue-500",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checked) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
      }, null, 544), [
        [_vModelCheckbox, _ctx.checked]
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? "*" : ""), 1)
    ])
  ]))
}